import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getUserCustomFieldValues({ userId }) {
    return axiosIns.get(
      '/v2/eod_closing/user_custom_field_values',
      {
        params: snakecaseKeys({ userId }),
      },
    )
  },
  // values: [{ storeCustomFieldId, value }]
  bulkUpdateUserCustomFieldValues({ userId, values }) {
    return axiosIns.put(
      '/v2/eod_closing/user_custom_field_values/bulk_update',
      snakecaseKeys({ userId, values }, { deep: true }),
    )
  },
}
